const { postSSTData } = require('../helpers/sst/postSstData');
const { createSSTData } = require('../helpers/sst/createSstData');

const sendTrackingToCloud = (message, alertType) => {
    postSSTData(
        createSSTData({
            jsonPayload: {
                eventType: 'frontendOnView',
                elementType: 'e10eElement', // errorMessageElement -> e10eElement
                e10eElement: [
                    {
                        message: message,
                        alertType: alertType,
                    },
                ],
            },
        })
    );
};

const initAlertTracking = () => {
      
      // 1. Setup Event Delegation (The Listener)
      // We attach to body once; it handles all current and future alerts
      $('body').on('show.bs.alert.custom, show.bs.alert.custom.intersect', function (ev) {    
        
        const typeClass = Object.values(ev.target.classList).find(c => c.includes('danger') || c.includes('warning'));
        
        if (typeClass) {
            sendTrackingToCloud(ev.target.innerText.trim(), typeClass);
        }
      });

      // 2. Setup Intersection Observer (The Trigger)
      const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            $(entry.target).trigger('show.bs.alert.custom.intersect');
            // Only stop observing if the alert is not inside a modal
            if (($(entry.target).closest('.modal-dialog')).length === 0) { 
               observer.unobserve(entry.target); // Stop observing once we've tracked it
            }
       }
        });
      };

      const observer = new IntersectionObserver(observerCallback, {
        root: null, // viewport
        threshold: 0.0 // Trigger when at least 10% of the alert is visible
      });

      // 3. Start Observing
      document.querySelectorAll('.alert:not(.js-alert)').forEach(alert => observer.observe(alert));
    
};


(() => {
    initAlertTracking();
})();